
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { COMPONENT_VISIBILITY } from "../types";
import BaseView from "./BaseView";
import User from "../entities/User";

@Component
export default class DebugView extends BaseView {
  @Getter("auth/user") user: User;

  @Getter("app/locale") currentLocale: string;

  topBarText = "Debug information";

  snackbarVisible = false;

  snackbarText = "";

  userAgent = navigator.userAgent;

  created() {
    this.setAppBackgroundColor("light");
    this.setTopBarVisibility(COMPONENT_VISIBILITY.hidden);
  }

  async copyValueToClipboard(value: any) {
    try {
      await navigator.clipboard.writeText(value || "");
      this.snackbarText = `Text copied:<br>${value}`;
      this.snackbarVisible = true;
    } catch (error: any) {
      this.snackbarText = error.message;
      this.snackbarVisible = true;
    }
  }
}
